export default __webpack_public_path__ + "c9753adaa5589c0e91f5c2fef8c6640f.png";